export default __webpack_public_path__ + "static/media/garen-bg.ca99738b.jpg";